import { atom } from "recoil";

const clickedConnexionAtom = atom({
  key: "clickedConnexionState",
  default: false,
});

export default clickedConnexionAtom;
